import ItineraryView from './ItineraryView';

export default ItineraryView;
